import React, { useEffect, useState } from "react";
import HttpApis from "../../services/HttpApis";
import { useNavigate, useParams } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { trackUserClick } from "../../services/Analytics";
import { useConfig } from "../../ConfigContext";
import "../SeeAll/SeeAll.css";
import Loader from "../loader/Loader";
import Footer from "../Footer/Footer";

const Genre = () => {
  const [genreData, setGenreData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const params = useParams();
  const genre_id = params?.genre_id || params?.id;
  const navigate = useNavigate();
  const config = useConfig();
  const enableLogin = config?.enable_login !== false;

  const fetchGenre = async (id) => {
    try {
      setLoading(true);
      setError(null);
      const response = await HttpApis.getGenrebyId(id);
      const data = response?.data;
      if (data && data.status === "success") {
        setGenreData(data);
      } else {
        setError("Failed to load genre content.");
      }
    } catch (err) {
      console.error("Error fetching genre:", err);
      setError("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (genre_id) {
      fetchGenre(genre_id);
    } else {
      setLoading(false);
      setError("Genre ID not found.");
    }
  }, [genre_id]);

  if (loading) return <Loader />;

  if (error) {
    return (
      <div className="genre">
        <div className="genre__container">
          <p className="genre__error">{error}</p>
        </div>
      </div>
    );
  }

  if (!genreData) return null;

  const genreName = genreData.data?.member?.name || "";
  const allItems = genreData.data?.content || [];

  const handleItemClick = async (item) => {
    if (!item?.slug) return;

    if (enableLogin) {
      try {
        await trackUserClick({
          action: "genre_item_click",
          contentId: item.slug || item.id,
          contentType: item.content_type,
          contentTitle: item.name,
          genreId: genre_id,
          genreTitle: genreName,
        });
      } catch (err) {
        console.error("Tracking failed:", err);
      }
    }

    navigate(`/details/${item.content_type}/${item.slug}`);
  };

  return (
    <div className="seeall-page" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1 }}>
        <div className="seeall-header">
          <button className="seeall-back" onClick={() => navigate(-1)} aria-label="Go back">
            <IoArrowBack />
          </button>
          <h1 className="seeall-title">{genreName}</h1>
        </div>

        {allItems.length === 0 && (
          <div className="seeall-empty">No titles to show.</div>
        )}

        {allItems.length > 0 && (
          <div className="seeall-grid">
            {allItems.map((item, index) => {
              const poster = item.thumbnail_image || item.portrait || item.landscape;
              return (
                <div
                  key={`${item.content_type}-${item.id}-${index}`}
                  className="seeall-card"
                  onClick={() => handleItemClick(item)}
                >
                  <div className="seeall-card__img-wrap portrait">
                    <img
                      src={poster}
                      alt={item.name}
                      className="seeall-card__img"
                      loading="lazy"
                      onError={(e) => { e.currentTarget.style.opacity = 0; }}
                    />
                  </div>
                  <p className="seeall-card__name">{item.name}</p>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Genre;